export default function Geofences() {
  return (
    <div style={{ padding: '1rem' }}>
      <h1>Geofences</h1>
    </div>
  );
}